import React from 'react'
import getCourseDifficultyLabel from '../../utils/getCourseDifficultyLabel';

type MetadataItem = {
  icon: React.ReactNode;
  title: string;
};

type Props = {
  items: MetadataItem[]
  card?: boolean
  smallText?: boolean
  alignLeft?: boolean
};

const Metadata: React.FunctionComponent<Props> = ({ items, smallText = false, alignLeft = false }) => {
  const getDisplayTitle = (title: string): string | null => {
    if (!title || title === "unspecified" || title === '0' || title === 'null') {
      return null;
    }

    return getCourseDifficultyLabel(title) || title;
  };

  const validItems = items.filter(item => getDisplayTitle(item.title) !== null);

  return (
    <div style={{ display: 'flex', justifyContent: "flex-start", alignItems: 'center', gap: '0.5rem', fontSize: smallText ? "12px" : "1rem", flexWrap: 'wrap'}}>
      {validItems.map((item, index) => {
        const displayTitle = getDisplayTitle(item.title);
        
        return (
          <React.Fragment key={index}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
              {item.icon}
              <span>{displayTitle}</span>
            </div>
            {index < validItems.length - 1 && (
              <span>|</span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Metadata;
